<template>
  <div class="container">
    <div class="max-w-xl" v-if="product">
      <BaseInput v-model="product.title" label="Produktnamn" />
      <BaseInput
        v-if="product.supplier"
        disabled
        v-model="product.supplier.name"
        label="Leverantör"
        class="mt-3"
      />

      <!-- <BaseInput
        v-if="product.brand"
        disabled
        v-model="product.brand.title"
        label="Märke"
        class="mt-3"
      /> -->
      <div class="mt-3 ">
        <span
          class="block mb-1 text-gray-900 tracking-wide text-sm font-semibold"
        >
          Märke
        </span>
        <select v-model="product.brandId" class="form-control">
          <option v-for="brand of brands" :value="brand.id" :key="brand.id">{{
            brand.title
          }}</option>
        </select>
      </div>
      <BaseInput v-model="product.series" label="Serie" class="mt-3" />
      <BaseTextarea
        v-model="product.description"
        label="Beskrivning"
        rows="7"
        class="mt-3"
      />
      <BaseInput v-model="product.barcode" label="Streckkod" class="mt-3" />
      <BaseInput
        v-model="product.barcodetwo"
        label="Streckkod 2"
        class="mt-3"
      />
      <div class="flex mt-3">
        <BaseInput v-model="product.weight" label="Vikt (gram)" unit="g" />
        <BaseInput v-model="product.size" label="Storlek (ml)" unit="ml" />
      </div>
      <div class="flex mt-3">
        <BaseInput
          v-model.number="product.recommendedConsumerPrice"
          label="Rek utpris"
          unit="kr"
          type="number"
        />
        <BaseInput
          v-model.number="product.recommendedSaloonPrice"
          label="Inpris"
          unit="kr"
          type="number"
        />
      </div>

      <button @click="handleSubmit" class="btn btn-secondary mt-4">
        Spara
      </button>
    </div>
  </div>
</template>

<script>
import UpdateProduct from '@/graphql/UpdateProduct.gql'
import { useBrands } from '@/composables/use-brands'

import gql from 'graphql-tag'
export default {
  setup() {
    const { brands } = useBrands()

    return {
      brands,
    }
  },
  data() {
    return {
      product: null,
    }
  },
  apollo: {
    product: {
      query: gql`
        query product($id: String!) {
          product(id: $id) {
            id
            displayImage
            title
            barcode
            barcodetwo
            size
            weight
            description
            series
            recommendedSaloonPrice
            recommendedConsumerPrice
            brandId
            supplier {
              id
              name
            }
          }
        }
      `,
      variables() {
        return {
          id: this.$route.params.id,
        }
      },
      fetchPolicy: 'cache-and-network',
    },
  },
  methods: {
    async handleSubmit() {
      await this.$apollo.mutate({
        mutation: UpdateProduct,
        variables: {
          data: {
            title: this.product.title,
            barcode: this.product.barcode,
            barcodetwo: this.product.barcodetwo,
            size: this.product.size,
            weight: this.product.weight,
            series: this.product.series,
            description: this.product.description,
            recommendedSaloonPrice: this.product.recommendedSaloonPrice,
            recommendedConsumerPrice: this.product.recommendedConsumerPrice,
            brandId: this.product.brandId,
          },
          id: this.$route.params.id,
        },
      })
      this.$router.push({ name: 'products' })
    },
  },
}
</script>

<style lang="scss" scoped></style>
